export default __webpack_public_path__ + "static/media/heart2.d402054b.svg";